define("shared/components/shared/pre-boarding/index", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/services/onboarding"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _onboarding) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/services/onboarding"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::PreBoarding::Survey @onCloseSelfDescribes={{this.onCloseSelfDescribes}} />
  
  {{#if this.shouldShowSocialConnectOnboarding}}
    <Shared::PreBoarding::SocialConnect @closeModal={{this.closeSocialConnectOnboarding.perform}} />
  {{/if}}
  
  {{#if this.shouldShowAutoTrialStartModal}}
    <Shared::PreBoarding::AutoTrialStart @closeModal={{this.closeAutoTrialStartModal}} />
  {{/if}}
  
  {{#if this.shouldShowAutoTrialEndModal}}
    <Shared::PreBoarding::AutoTrialEnd
      @toggleAutoTrialEndModal={{this.toggleAutoTrialEndModal}}
      @trialedPlan={{this.trialedPlan}}
    />
  {{/if}}
  
  {{#if this.shouldShowSourcelessTrialExpiryModal}}
    <Shared::PreBoarding::SourcelessTrialEnd
      @toggleSourceLessTrialEndModal={{this.toggleSourceLessTrialEndModal}}
      @trialedPlan={{this.sourcelessTrialedPlan}}
    />
  {{/if}}
  */
  {
    "id": "vzx/bZvC",
    "block": "[[[8,[39,0],null,[[\"@onCloseSelfDescribes\"],[[30,0,[\"onCloseSelfDescribes\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"shouldShowSocialConnectOnboarding\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@closeModal\"],[[30,0,[\"closeSocialConnectOnboarding\",\"perform\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowAutoTrialStartModal\"]],[[[1,\"  \"],[8,[39,3],null,[[\"@closeModal\"],[[30,0,[\"closeAutoTrialStartModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowAutoTrialEndModal\"]],[[[1,\"  \"],[8,[39,4],null,[[\"@toggleAutoTrialEndModal\",\"@trialedPlan\"],[[30,0,[\"toggleAutoTrialEndModal\"]],[30,0,[\"trialedPlan\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowSourcelessTrialExpiryModal\"]],[[[1,\"  \"],[8,[39,5],null,[[\"@toggleSourceLessTrialEndModal\",\"@trialedPlan\"],[[30,0,[\"toggleSourceLessTrialEndModal\"]],[30,0,[\"sourcelessTrialedPlan\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"shared/pre-boarding/survey\",\"if\",\"shared/pre-boarding/social-connect\",\"shared/pre-boarding/auto-trial-start\",\"shared/pre-boarding/auto-trial-end\",\"shared/pre-boarding/sourceless-trial-end\"]]",
    "moduleName": "shared/components/shared/pre-boarding/index.hbs",
    "isStrictMode": false
  });

  let PreBoardingComponent = (_class = class PreBoardingComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "cache", _descriptor2, this);

      _initializerDefineProperty(this, "onboarding", _descriptor3, this);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);

      _initializerDefineProperty(this, "trialedPlan", _descriptor7, this);

      _initializerDefineProperty(this, "shouldShowAutoTrialStartModal", _descriptor8, this);

      _initializerDefineProperty(this, "shouldShowAutoTrialEndModal", _descriptor9, this);

      _initializerDefineProperty(this, "shouldSourcelessTrialEndModalBeVisible", _descriptor10, this);

      _defineProperty(this, "closeSocialConnectOnboarding", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.SKIPPED_SOCIAL_CONNECT);

          if (!this.hasConnectedSocialProfile) {
            this.segment.track('skipped-social-connect', {
              area: 'social-connect-modal-onboarding'
            });
          }
        }
      }), null, "closeSocialConnectOnboarding", null));

      _defineProperty(this, "loadRecentlyExpiredPlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.trialedPlan = yield this.subscriptions.getSubscriptionPlan('recently_expired');
        }
      }), null, "loadRecentlyExpiredPlan", null));

      this.loadRecentlyExpiredPlan.perform();
      this.shouldShowAutoTrialEndModal = this.autoTrialSubscriptionExpired && !this.subscriptions.cardlessTrialCampaignCompleted;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get autoTrialSubscriptionExpired() {
      return this.subscriptions.planType === 'free' && this.subscriptions.isLatestSubscriptionAutoTrial;
    }

    get sourcelessTrialSubscriptionExpired() {
      return this.subscriptions.planType === 'free' && this.subscriptions.isLatestSubscriptionSourcelessTrial;
    }

    get shouldShowSocialConnectOnboarding() {
      return this.onboarding.shouldShowSocialConnectOnboarding;
    }

    get shouldShowSourcelessTrialExpiryModal() {
      return this.sourcelessTrialSubscriptionExpired && !this.subscriptions.cardlessTrialCampaignCompleted && this.shouldSourcelessTrialEndModalBeVisible;
    }

    get hasConnectedSocialProfile() {
      return this.auth.currentGroup.socialProfiles.get('length') > 0;
    }

    closeAutoTrialStartModal() {
      this.shouldShowAutoTrialStartModal = false;
      this.showPowerUserOnboardingSocialConnectModal();
    }

    toggleAutoTrialEndModal() {
      this.shouldShowAutoTrialEndModal = !this.shouldShowAutoTrialEndModal;
    }

    toggleSourceLessTrialEndModal() {
      this.shouldSourcelessTrialEndModalBeVisible = !this.shouldSourcelessTrialEndModalBeVisible;
    }

    async showPowerUserOnboardingSocialConnectModal() {
      await this.onboarding.setPowerUserOnboardingState.perform(_onboarding.POWER_USER_ONBOARDING_STATES.CONNECTING_SOCIAL);
    }

    onCloseSelfDescribes() {
      if (this.subscriptions.isOnAutoTrial) {
        this.shouldShowAutoTrialStartModal = true;
      } else if (this.auth.currentAccount.canTrialPlan) {
        this.seamlessCheckoutManager.openTrialPlansModal({
          onCloseOrSuccess: this.showPowerUserOnboardingSocialConnectModal,
          location: 'onboarding_plan_snapshot',
          trialStartLocation: 'create account onboarding'
        });
      } else {
        this.showPowerUserOnboardingSocialConnectModal();
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "trialedPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAutoTrialStartModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldShowAutoTrialEndModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "shouldSourcelessTrialEndModalBeVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeAutoTrialStartModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAutoTrialStartModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAutoTrialEndModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAutoTrialEndModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSourceLessTrialEndModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSourceLessTrialEndModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPowerUserOnboardingSocialConnectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showPowerUserOnboardingSocialConnectModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCloseSelfDescribes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCloseSelfDescribes"), _class.prototype)), _class);
  _exports.default = PreBoardingComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PreBoardingComponent);
});